import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalMetrics } from '../../../models'
import { doohMetricNames } from './dooh-metric-names'

export const doohAudienceMetricNames: Array<TGlobalMetrics> =
  doohMetricNames.filter(
    (header) =>
      !(
        header === EReportColumnHeader.ShareOfVoice ||
        header === EReportColumnHeader.WinRate
      )
  )
